export function mapApprovalStatuses(statuses) {
  if (!Array.isArray(statuses) || statuses.length === 0) return null

  if (statuses.some(s => s === 'pending')) return 'approvalPending'

  if (statuses.some(s => s === 'rejected' || s === 'auto_rejected')) {
    return 'approvalRejected'
  }

  if (statuses.every(s => s === 'approved')) return 'approved'

  return null
}
